// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/chat/form_submission_workflow_state.proto (package qliq_protobuf.chat, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum qliq_protobuf.chat.FormSubmissionWorkflowState
 */
export enum FormSubmissionWorkflowState {
  /**
   * @generated from enum value: FORM_SUBMISSION_WORKFLOW_STATE_UNKNOWN = 0;
   */
  FORM_SUBMISSION_WORKFLOW_STATE_UNKNOWN = 0,

  /**
   * @generated from enum value: OPENED = 1;
   */
  OPENED = 1,

  /**
   * @generated from enum value: SUBMITTED = 2;
   */
  SUBMITTED = 2,

  /**
   * @generated from enum value: UPLOADING = 3;
   */
  UPLOADING = 3,

  /**
   * @generated from enum value: UPLOAD_FAILED = 4;
   */
  UPLOAD_FAILED = 4,

  /**
   * @generated from enum value: UPLOADED = 5;
   */
  UPLOADED = 5,

  /**
   * @generated from enum value: ABANDONED = 6;
   */
  ABANDONED = 6,

  /**
   * @generated from enum value: CREATED = 7;
   */
  CREATED = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(FormSubmissionWorkflowState)
proto3.util.setEnumType(FormSubmissionWorkflowState, "qliq_protobuf.chat.FormSubmissionWorkflowState", [
  { no: 0, name: "FORM_SUBMISSION_WORKFLOW_STATE_UNKNOWN" },
  { no: 1, name: "OPENED" },
  { no: 2, name: "SUBMITTED" },
  { no: 3, name: "UPLOADING" },
  { no: 4, name: "UPLOAD_FAILED" },
  { no: 5, name: "UPLOADED" },
  { no: 6, name: "ABANDONED" },
  { no: 7, name: "CREATED" },
]);

